(function ($) {
    //フロントページメインスライダー
    $('#slick').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
    });

    // スマホでフッターメニューの表示切り替え
    $('.sp-footer-menu').click(function () {

        if ($(this).hasClass('footer-menu-open')) {
            $(this).removeClass('footer-menu-open');
            $(this).next().slideUp();
            $(this).find('p').text('メニューを表示する');
            $(this).find('.sp-menu-icon').text('+');
        } else {
            $(this).addClass('footer-menu-open');
            $(this).next().slideDown();
            $(this).find('p').text('メニューを閉じる');
            $(this).find('.sp-menu-icon').text('-');
        }

    });

    // フッターメニューのliに任意のクラスを付与
    $('#footer-menu').children().addClass('col-xl-3 col-lg-4 col-sm-6 col-12');


    // パンくずリストと隣接しているときにクラス追加
    $('.breadcrumbs').parent().addClass('has_breadcrumb');



})(jQuery);